(function () {
  const ppProducts = {
    pola20: {
      name: "POLA 2.0 Plug & Play - mit Erdspieß",
      group: "Wegebeleuchtung",
      watt: 4.5,
      variants: {
        anthrazit: 49473983938895,
        bronze: 49473983971663
      }
    },
    pola21: {
      name: "POLA 2.1 Plug & Play - mit Sockel zum Verschrauben",
      group: "Wegebeleuchtung",
      watt: 4.5,
      variants: {
        anthrazit: 49473983709519,
        bronze: 49473983742287
      }
    },
    geo10: {
      name: "GEO 1.0 Strahler Plug & Play - 280 mm hoch",
      group: "Strahler",
      watt: 3.7,
      variants: {
        anthrazit: 49473985610063,
        bronze: 49473985642831
      }
    },
    geo20: {
      name: "GEO 2.0 Strahler Plug & Play - 450 mm hoch",
      group: "Strahler",
      watt: 7.2,
      variants: {
        anthrazit: 55100924199247,
        bronze: 55100924232015
      }
    },
    reed10: {
      name: "REED 1.0 Plug & Play - 415 mm hoch",
      group: "Flächenbeleuchtung",
      watt: 4.2,
      variants: {
        anthrazit: 49473985478991,
        bronze: 49473985511759
      }
    },
    reed20: {
      name: "REED 2.0 Plug & Play - 715 mm hoch",
      group: "Flächenbeleuchtung",
      watt: 5.3,
      variants: {
        anthrazit: 49473985380687,
        bronze: 49473985413455
      }
    }
  };

  const ppAccessories = {
    driver30: 49473983807823,
    driver75: 49473983840591,
    tConnector: 49473985708367,
    straightConnector: 49473985675599,
    cable05: 57802578264399,
    cable10: 57802614604111,
    cable25: 49473985773903,
    cable50: 49473985806671
  };

  const ppCableOptions = [
    { length: 5.0, id: ppAccessories.cable50, name: "Verlängerungskabel 5 m" },
    { length: 2.5, id: ppAccessories.cable25, name: "Verlängerungskabel 2,5 m" },
    { length: 1.0, id: ppAccessories.cable10, name: "Verlängerungskabel 1 m" },
    { length: 0.5, id: ppAccessories.cable05, name: "Verlängerungskabel 0,5 m" }
  ];

  let ppLampCounter = 0;

  function ppAddLamp(type, distance) {
    type = type || "pola20";
    distance = distance || 2.5;

    const lampList = document.getElementById("pp-lamp-list");
    if (!lampList) return;

    ppLampCounter += 1;

    const wrapper = document.createElement("div");
    wrapper.className = "pp-form-row";
    wrapper.dataset.row = ppLampCounter;

    const labelText = ppLampCounter === 1
      ? "Abstand vom Treiber in Meter"
      : "Abstand zur vorherigen Leuchte in Meter";

    wrapper.innerHTML =
      '<div>' +
        '<label>Leuchte ' + ppLampCounter + '</label>' +
        '<select class="pp-lamp-type">' +
          '<optgroup label="Wegebeleuchtung">' +
            '<option value="pola20">POLA 2.0 - mit Erdspieß für Beet, Rasen und Erde</option>' +
            '<option value="pola21">POLA 2.1 - mit Sockel zum Verschrauben auf festen Untergründen</option>' +
          '</optgroup>' +
          '<optgroup label="Strahler">' +
            '<option value="geo10">GEO 1.0 - 280 mm hoch</option>' +
            '<option value="geo20">GEO 2.0 - 450 mm hoch</option>' +
          '</optgroup>' +
          '<optgroup label="Flächenbeleuchtung">' +
            '<option value="reed10">REED 1.0 - 415 mm hoch</option>' +
            '<option value="reed20">REED 2.0 - 715 mm hoch</option>' +
          '</optgroup>' +
        '</select>' +
      '</div>' +
      '<div>' +
        '<label>' + labelText + '</label>' +
        '<input class="pp-distance" type="number" min="0" step="0.1" value="' + distance + '">' +
      '</div>' +
      '<div>' +
        '<label>&nbsp;</label>' +
        '<button type="button" class="pp-remove">Entfernen</button>' +
      '</div>';

    lampList.appendChild(wrapper);

    const select = wrapper.querySelector(".pp-lamp-type");
    if (select) select.value = type;

    const removeButton = wrapper.querySelector(".pp-remove");
    if (removeButton) {
      removeButton.addEventListener("click", function () {
        wrapper.remove();
      });
    }
  }

  function ppAddToCartItems(items, id, qty) {
    if (!qty || qty <= 0) return;
    items[id] = (items[id] || 0) + qty;
  }

  function ppBestCableCombination(extraLength) {
    if (extraLength <= 0) {
      return {
        totalLength: 0,
        cables: []
      };
    }

    let best = null;

    for (let a = 0; a <= 20; a++) {
      for (let b = 0; b <= 20; b++) {
        for (let c = 0; c <= 20; c++) {
          for (let d = 0; d <= 20; d++) {
            const total = a * 5 + b * 2.5 + c * 1 + d * 0.5;
            const count = a + b + c + d;

            if (total < extraLength || count === 0) continue;

            const overshoot = total - extraLength;

            const candidate = {
              totalLength: total,
              count: count,
              overshoot: overshoot,
              cables: []
            };

            for (let i = 0; i < a; i++) candidate.cables.push(ppCableOptions[0]);
            for (let i = 0; i < b; i++) candidate.cables.push(ppCableOptions[1]);
            for (let i = 0; i < c; i++) candidate.cables.push(ppCableOptions[2]);
            for (let i = 0; i < d; i++) candidate.cables.push(ppCableOptions[3]);

            if (
              best === null ||
              candidate.overshoot < best.overshoot ||
              (candidate.overshoot === best.overshoot && candidate.count < best.count)
            ) {
              best = candidate;
            }
          }
        }
      }
    }

    return best;
  }

  function ppFormatMeter(value) {
    return value.toFixed(1).replace(".", ",") + " m";
  }

  function ppFormatWatt(value) {
    return value.toFixed(1).replace(".", ",") + " W";
  }

  function ppCalculate() {
    const colorSelect = document.getElementById("pp-color");
    const output = document.getElementById("pp-output");

    if (!colorSelect || !output) return;

    const color = colorSelect.value;
    const rows = Array.from(document.querySelectorAll("#pp-lamp-list .pp-form-row"));

    output.style.display = "block";

    if (rows.length === 0) {
      output.innerHTML = "<p>Bitte fügen Sie mindestens eine Leuchte hinzu.</p>";
      return;
    }

    let cartItems = {};
    let totalWatt = 0;
    let lampCount = 0;
    let cableSummary = {};
    let lineConnectorCount = 0;
    let lampRowsHtml = "";
    let cableRowsHtml = "";
    let warningHtml = "";

    rows.forEach(function (row, index) {
      const type = row.querySelector(".pp-lamp-type").value;
      const distance = parseFloat(row.querySelector(".pp-distance").value || "0");
      const product = ppProducts[type];

      lampCount += 1;
      totalWatt += product.watt;

      ppAddToCartItems(cartItems, product.variants[color], 1);

      const includedLength = 2.5;
      const extraLength = Math.max(0, distance - includedLength);
      const cableCombo = ppBestCableCombination(extraLength);

      if (cableCombo && cableCombo.cables.length > 0) {
        cableCombo.cables.forEach(function (cable) {
          ppAddToCartItems(cartItems, cable.id, 1);
          cableSummary[cable.name] = (cableSummary[cable.name] || 0) + 1;
        });

        const neededLineConnectors = Math.max(0, cableCombo.cables.length - 1);
        lineConnectorCount += neededLineConnectors;

        cableRowsHtml +=
          "<tr>" +
            "<td>" + (index === 0 ? "Treiber zu Leuchte 1" : "Leuchte " + index + " zu Leuchte " + (index + 1)) + "</td>" +
            "<td>" + ppFormatMeter(distance) + "</td>" +
            "<td>" + ppFormatMeter(extraLength) + "</td>" +
            "<td>" + cableCombo.cables.map(function (c) { return c.name; }).join(" + ") + "</td>" +
            "<td>" + ppFormatMeter(cableCombo.totalLength) + " Zusatz</td>" +
          "</tr>";
      } else {
        cableRowsHtml +=
          "<tr>" +
            "<td>" + (index === 0 ? "Treiber zu Leuchte 1" : "Leuchte " + index + " zu Leuchte " + (index + 1)) + "</td>" +
            "<td>" + ppFormatMeter(distance) + "</td>" +
            "<td>0 m</td>" +
            "<td>Kein zusätzliches Kabel nötig</td>" +
            "<td>2,5 m bereits vorhanden</td>" +
          "</tr>";
      }

      lampRowsHtml +=
        "<tr>" +
          "<td>" + (index + 1) + "</td>" +
          "<td>" + product.group + "</td>" +
          "<td>" + product.name + "</td>" +
          "<td>" + ppFormatWatt(product.watt) + "</td>" +
        "</tr>";
    });

    let driverId = null;
    let driverName = "";

    if (totalWatt <= 30) {
      driverId = ppAccessories.driver30;
      driverName = "Plug & Play Treiber 30 W";
    } else if (totalWatt <= 75) {
      driverId = ppAccessories.driver75;
      driverName = "Plug & Play Treiber 75 W";
    } else {
      warningHtml =
        '<div class="pp-warning">' +
          'Die Gesamtleistung liegt über 75 W. Bitte teilen Sie die Planung auf mehrere Systeme auf oder kontaktieren Sie uns für eine individuelle Planung.' +
        '</div>';
    }

    if (driverId) {
      ppAddToCartItems(cartItems, driverId, 1);
    }

    ppAddToCartItems(cartItems, ppAccessories.tConnector, lampCount);

    if (lineConnectorCount > 0) {
      ppAddToCartItems(cartItems, ppAccessories.straightConnector, lineConnectorCount);
    }

    let accessoriesHtml = "";

    accessoriesHtml +=
      "<tr>" +
        "<td>" + (driverName || "Treiber individuell prüfen") + "</td>" +
        "<td>" + (driverName ? "1" : "-") + "</td>" +
      "</tr>" +
      "<tr>" +
        "<td>T-Verbinder</td>" +
        "<td>" + lampCount + "</td>" +
      "</tr>";

    Object.keys(cableSummary).forEach(function (name) {
      accessoriesHtml +=
        "<tr>" +
          "<td>" + name + "</td>" +
          "<td>" + cableSummary[name] + "</td>" +
        "</tr>";
    });

    if (lineConnectorCount > 0) {
      accessoriesHtml +=
        "<tr>" +
          "<td>Linienverbinder</td>" +
          "<td>" + lineConnectorCount + "</td>" +
        "</tr>";
    }

    const cartUrl = "/cart/" + Object.entries(cartItems)
      .map(function ([id, qty]) {
        return id + ":" + qty;
      })
      .join(",");

    output.innerHTML =
      '<h3>Ihre berechnete Plug & Play Planung</h3>' +
      '<p><strong>Gewählte Farbe:</strong> ' + (color === "anthrazit" ? "Anthrazit" : "Bronze") + '</p>' +
      '<p><strong>Gesamtleistung:</strong> ' + ppFormatWatt(totalWatt) + '</p>' +
      '<p><strong>Empfohlener Treiber:</strong> ' + (driverName || "Bitte individuell prüfen") + '</p>' +
      warningHtml +
      '<h3>Gewählte Leuchten</h3>' +
      '<div class="pp-table-wrap">' +
        '<table class="pp-table">' +
          '<thead>' +
            '<tr>' +
              '<th>Position</th>' +
              '<th>Bereich</th>' +
              '<th>Leuchte</th>' +
              '<th>Leistung</th>' +
            '</tr>' +
          '</thead>' +
          '<tbody>' + lampRowsHtml + '</tbody>' +
        '</table>' +
      '</div>' +
      '<h3>Kabelberechnung</h3>' +
      '<div class="pp-table-wrap">' +
        '<table class="pp-table">' +
          '<thead>' +
            '<tr>' +
              '<th>Verbindung</th>' +
              '<th>Gewünschter Abstand</th>' +
              '<th>Zusatzbedarf</th>' +
              '<th>Benötigte Kabel</th>' +
              '<th>Geplante Zusatzlänge</th>' +
            '</tr>' +
          '</thead>' +
          '<tbody>' + cableRowsHtml + '</tbody>' +
        '</table>' +
      '</div>' +
      '<h3>Automatisch hinzugefügtes Zubehör</h3>' +
      '<div class="pp-table-wrap">' +
        '<table class="pp-table">' +
          '<thead>' +
            '<tr>' +
              '<th>Artikel</th>' +
              '<th>Menge</th>' +
            '</tr>' +
          '</thead>' +
          '<tbody>' + accessoriesHtml + '</tbody>' +
        '</table>' +
      '</div>' +
      '<div class="pp-note">' +
        '<strong>Hinweis zur Verlegung:</strong> Die 24V-Leitungen müssen nicht zwingend wie klassische 230V-Leitungen tief unterirdisch verlegt werden. Zum Schutz vor Beschädigungen durch Spaten, Rasenpflege oder andere Gartengeräte ist eine geschützte oder eingegrabene Verlegung jedoch empfehlenswert.' +
      '</div>' +
      (
        totalWatt <= 75
          ? '<a class="pp-button" href="' + cartUrl + '">Alle Artikel in den Warenkorb legen</a>'
          : '<p class="pp-warning">Bitte kontaktieren Sie uns für eine Planung über 75 W.</p>'
      );
  }

  function ppInitPlanner() {
    const addLampButton = document.getElementById("pp-add-lamp");
    const calculateButton = document.getElementById("pp-calculate");

    if (!addLampButton || !calculateButton) return;

    addLampButton.addEventListener("click", function () {
      ppAddLamp();
    });

    calculateButton.addEventListener("click", function () {
      ppCalculate();
    });

    ppAddLamp("pola20", 2.5);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ppInitPlanner);
  } else {
    ppInitPlanner();
  }
})();